export enum PermissionSubject {
  ALL = "all",
  USER = "user",
  ORGANIZATION = "organization",
  BILLING = "billing",
  BOOKING = "booking",
  BOOKING_SETTINGS = "booking_settings",
  ENTRY_PACK = "entry_pack",
  TRAINING_PLAN = "training_plan",
  DIET_PLAN = "diet_plan",
  PROGRESS = "progress",
  EXERCISE = "exercise",
  /** Money the business takes in: payments, refunds, invoices, payouts, its payment account. */
  FINANCE = "finance",
  /** What the business sells besides sessions and events. */
  OFFER = "offer",
}
